import { SubscriptionProductType } from '../../../../../services/exports/Constants';

export default {
  title: 'Produs nou',
  fields: {
    type: {
      label: 'Tip produs',
      options: {
        [SubscriptionProductType.Plan]: 'Plan',
        [SubscriptionProductType.AddOn]: 'Supliment',
        [SubscriptionProductType.GoogleAdsPlan]: 'Google Ads Plan',
      },
    },
    name: {
      label: 'Nume intern',
      placeholder: 'Introduceți numele intern al produsului',
    },
    public_name: {
      label: 'Nume public',
      placeholder: 'Introduceți numele public al produsului',
    },
    description: {
      label: 'Descriere',
    },
  },
  buttons: {
    save: 'Salvați',
    cancel: 'Anulați',
  },
  feedback: {
    missing_info: 'Informații lipsă',
  },
  toasts: {
    plan_got_created: 'Produsul a fost creat',
    plan_got_updated: 'Produsul a fost actualizat',
  },
};
